// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-wDF","index":"styles_index__1910G"};